import { UsersWrapper } from '../../components'

export default function UsersPage() {
  return (
    <div className="spacer-sm">
      <UsersWrapper />
    </div>
  )
}
